import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const ParametersInsuranceSchema = z.object({
  optionInsuranceActive: z.boolean(),
  insurancePercentage: z
    .number({
      message: i18nMessage("shared:forms.clientParameters.insuranceRateRequired"),
      coerce: true,
    })
    .min(0, { message: i18nMessage("shared:forms.clientParameters.insuranceRateNegative") }),
});

export type ParametersInsuranceFormData = z.infer<typeof ParametersInsuranceSchema>;

export const ParametersDapSchema = z.object({
  optionDAPActive: z.boolean({
    message: i18nMessage("shared:forms.clientParameters.dapOptionRequired"),
  }),
});

export type ParametersDapFormData = z.infer<typeof ParametersDapSchema>;

export const ParametersContactSchema = z.object({
  contactPhoneNumber: z
    .string({
      required_error: i18nMessage("shared:forms.clientParameters.phoneRequired"),
    })
    .refine((mobile) => isValidPhoneNumber(mobile), {
      message: i18nMessage("validation:invalidPhoneNumber"),
    }),
  contactEmail: z
    .string({
      required_error: i18nMessage("shared:forms.clientParameters.emailRequired"),
    })
    .email({
      message: i18nMessage("validation:invalidEmail"),
    })
    .min(1, i18nMessage("shared:forms.clientParameters.emailRequired")),
});

export type ParametersContactFormData = z.infer<typeof ParametersContactSchema>;

export const ParametersTarifSchema = z.object({
  tarifId: z
    .string({ message: i18nMessage("shared:forms.clientParameters.tariffRequired") })
    .min(1, i18nMessage("shared:forms.clientParameters.tariffRequired")),
});

export type ParametersTarifFormData = z.infer<typeof ParametersTarifSchema>;

export const ParametersPaymentTermSchema = z.object({
  paymentTerm: z
    .number({ message: i18nMessage("shared:forms.clientParameters.paymentTermRequired") })
    .min(0, i18nMessage("shared:forms.clientParameters.paymentTermRequired")),
});

export type ParametersPaymentTermFormData = z.infer<typeof ParametersPaymentTermSchema>;

export const ParametersCompanyStatusSchema = z.object({
  status: z.enum(["PENDING", "BLOCKED", "ACTIVE"], {
    message: i18nMessage("shared:forms.clientParameters.statusRequired"),
  }),
});

export type ParametersCompanyStatusFormData = z.infer<typeof ParametersCompanyStatusSchema>;

export const ParametersRibSchema = z.object({
  ribId: z
    .string({ message: i18nMessage("shared:forms.clientParameters.ribRequired") })
    .min(1, i18nMessage("shared:forms.clientParameters.ribRequired")),
});

export type ParametersRibFormData = z.infer<typeof ParametersRibSchema>;

export const ParametersImporterSchema = z.object({
  importerId: z
    .string({ message: i18nMessage("shared:forms.clientParameters.importerRequired") })
    .min(1, i18nMessage("shared:forms.clientParameters.importerRequired")),
});

export type ParametersImporterFormData = z.infer<typeof ParametersImporterSchema>;

export const ParametersBusinessNameSchema = z.object({
  businessName: z
    .string({ message: i18nMessage("shared:forms.clientParameters.businessNameRequired") })
    .min(1, i18nMessage("shared:forms.clientParameters.businessNameRequired")),
});

export type ParametersBusinessNameFormData = z.infer<typeof ParametersBusinessNameSchema>;
